import React from "react";
import { FormattedMessage, IntlProvider, useIntl } from "react-intl";
import Header from "@shared/components/Header";
import Loader from "@shared/components/Loader";
import Footer from "@shared/components/Footer";
import Main from "@shared/components/Main";
import { useData } from "@shared/context/Data";
import styles from "@shared/styles/app.styles.css";
import TermsAndConditions from "../TermsAndConditions";
const logo = require("../../assets/logo1024.png");
function HeaderWithIntl() {
    const intl = useIntl();
    return (React.createElement(Header, { link: "/phrasal-verbs/", logoSrc: logo, logoAlt: intl.formatMessage({ id: "LogoAltText" }), mainTitle: React.createElement(FormattedMessage, { id: "MainTitle" }) }));
}
function App() {
    const { messages, language, isLoading } = useData();
    return (React.createElement(IntlProvider, { locale: language, messages: messages }, isLoading
        ? React.createElement(Loader, null)
        : (React.createElement("div", { className: styles.container },
            React.createElement(HeaderWithIntl, null),
            React.createElement(Main, null,
                React.createElement(TermsAndConditions, null)),
            React.createElement(Footer, null)))));
}
export default App;
